import React, { forwardRef, LegacyRef } from 'react'

import styles from '../style.module.less'
import { BaseIconProps } from '../types'

export const DownMove = forwardRef(
  (
    { _width, _height, _fill, className, spin, rtl, ...rest }: BaseIconProps,
    root: LegacyRef<SVGSVGElement>
  ) => {
    return (
      <svg
        ref={root}
        width={_width}
        height={_height}
        viewBox="0 0 48 48"
        preserveAspectRatio="xMidYMid meet"
        fill="none"
        role="presentation"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ''} ${spin ? styles.spin : ''} ${
          rtl ? styles.rtl : ''
        }`.trim()}
        {...rest}
      >
        <g>
          <defs>
            <clipPath id="bb492__a">
              <rect
                rx="0"
                height="48"
                width="48"
              />
            </clipPath>
          </defs>
          <g
            clipPath="url(#bb492__a)"
            style={{ mixBlendMode: 'passthrough' }}
          >
            <path
              fillRule="evenodd"
              d="M15.273 25H22V6.985C22 5.88 22.91 5 24.015 5h.033C25.153 5 26 5.88 26 6.985V25h6.727c.87 0 1.325 1.034.737 1.676l-8.727 9.52a1 1 0 0 1-1.474 0l-8.727-9.52c-.588-.642-.133-1.676.737-1.676ZM5 40.952v.033C5 42.09 5.887 43 6.992 43h34.016C42.113 43 43 42.153 43 41.048v-.033C43 39.91 42.113 39 41.008 39H6.992C5.887 39 5 39.847 5 40.952"
              style={{ mixBlendMode: 'passthrough' }}
              data-follow-fill="#455766"
              fill={_fill}
            />
          </g>
        </g>
      </svg>
    )
  }
)
